import { defineComponent as P, ref as f, reactive as O, computed as R, watch as $, toRefs as H, onMounted as U, nextTick as V, provide as F, openBlock as G, createElementBlock as I, normalizeClass as r, unref as s, createElementVNode as l, withModifiers as J, toDisplayString as Q, withDirectives as X, normalizeStyle as Y, renderSlot as Z, vShow as ee } from "vue";
import { selectProps as te, selectContextKey as se } from "./select.js";
import { useNamespace as oe } from "../../hooks/use-namespace.js";
import "../../hooks/use-z-index.js";
import "./select.css";
const ne = /* @__PURE__ */ l("svg", {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    fill: "currentColor",
    d: "M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"
  })
], -1), le = [
  ne
], de = /* @__PURE__ */ P({
  __name: "select",
  props: te,
  emits: ["update:modelValue", "change"],
  setup(x, { emit: S }) {
    const u = x, h = S, n = oe("select"), d = f(null), g = f(), p = f(), C = f(""), t = O({
      options: /* @__PURE__ */ new Map(),
      cachedOptions: /* @__PURE__ */ new Map(),
      optionsCount: 0,
      visible: !1,
      selectedLabel: "",
      selected: {}
    }), M = R(
      () => Array.from(t.cachedOptions.values())
    ), T = (e, o) => {
      t.selectedLabel = e.currentLabel, h("update:modelValue", e.value), V(() => h("change", e.value)), t.visible = !1, t.visible;
    }, W = () => {
      t.visible = !1;
    };
    $(
      () => u.modelValue,
      (e, o) => {
        v();
      },
      {
        flush: "post",
        deep: !0
      }
    );
    const v = () => {
      const e = D(u.modelValue);
      e && (t.selectedLabel = e.currentLabel, t.selected = e);
    }, m = (e) => Object.prototype.toString.call(e).slice(8, -1), B = (e) => {
      t.optionsCount++, t.options.set(e.value, e), t.cachedOptions.set(e.value, e);
    }, D = (e) => {
      let o;
      const a = m(e).toLowerCase() === "object";
      m(e).toLowerCase(), m(e).toLowerCase();
      for (let i = t.cachedOptions.size - 1; i >= 0; i--) {
        const c = M.value[i];
        if (a ? c.value[u.valueKey] === e[u.valueKey] : c.value === e) {
          o = {
            value: e,
            currentLabel: c.currentLabel,
            isDisabled: c.isDisabled
          };
          break;
        }
      }
      if (o)
        return o;
    };
    function z() {
      var e;
      C.value = `${(e = d.value) == null ? void 0 : e.offsetWidth}px`;
    }
    const { selectedLabel: j, visible: b } = H(t);
    let y;
    const K = (e, o) => {
      var w, _, k, E;
      const a = e.target, i = o == null ? void 0 : o.target, c = !a || !i, L = ((w = d.value) == null ? void 0 : w.contains(a)) || ((_ = d.value) == null ? void 0 : _.contains(i)), A = d.value === a, N = p.value && (((k = p.value) == null ? void 0 : k.contains(a)) || ((E = p.value) == null ? void 0 : E.contains(i)));
      c || L || A || N || W();
    };
    U(() => {
      V(() => {
        g.value && z();
      }), v(), document.addEventListener(
        "mousedown",
        (e) => y = e
      ), document.addEventListener("mouseup", (e) => {
        K(e, y);
      });
    }), F(
      se,
      O({
        props: u,
        changeEvent: T,
        setSelected: v,
        onOptionCreate: B
      })
    );
    const q = (e) => {
      t.visible = !t.visible;
    };
    return (e, o) => (G(), I("div", {
      ref_key: "selectWrapper",
      ref: d,
      class: r([s(n).b(), s(n).is("open", s(b))])
    }, [
      l("div", {
        role: "button",
        ref_key: "reference",
        ref: g,
        class: r(s(n).e("trigger")),
        onClick: J(q, ["stop"])
      }, [
        l("div", null, Q(s(j)), 1),
        l("div", {
          class: r(s(n).e("suffix"))
        }, [
          l("div", {
            class: r([s(n).e("icon"), s(n).is("is-reverse", s(b))])
          }, le, 2)
        ], 2)
      ], 2),
      X(l("div", {
        class: r(s(n).e("content"))
      }, [
        l("ul", {
          ref_key: "refList",
          ref: p,
          class: r(s(n).e("list")),
          style: Y({ minWidth: C.value })
        }, [
          Z(e.$slots, "default")
        ], 6)
      ], 2), [
        [ee, s(b)]
      ])
    ], 2));
  }
});
export {
  de as default
};
